import { useEffect } from "react";

export default function useHoloXRPageTitle(title: string) {
    useEffect(() => {
        document.title = `HoloXR - ${title}`;
    }, [title]);
}
